export const getSmallerText = (text: string, maxLength: number) => {
  if (text?.length > maxLength) {
    return true;
  }
  return false;
};
